export const config = {
    /** The base URL. */
    baseURL: "/PSL/api",

    /** Max number of recent work items to be stored. */
    recentWorkCountMax: 10
};



// WEBPACK FOOTER //
// ./src/services/Config.tsx